export const noop = (): void => undefined;

export const checkTranslation = (label: string, intl: any): string => {
  const translationExists = !!intl.messages[`toolbox.fields.${label}`];
  return translationExists ? intl.formatMessage({ id: `toolbox.fields.${label}` }) : label;
};
